import { Checkbox } from "antd";
import { get, isEmpty } from "lodash";

import globalStyles from "./CategoryElements.module.scss";

const CategoryElementCheckbox = ({
  parameter,
  handleChange,
  selected,
  options = {},
}) => {
  const {
    id: parameterId,
    name: parameterName,
    urlTitle: parameterTitle,
  } = parameter;

  const parameterValues = get(parameter, "values", []);

  if (isEmpty(parameterValues)) {
    return "";
  }

  const {
    showMoreActive = false,
    showMoreEnabled = false,
    showMoreLimit = 0,
    showMoreToggle,
    styles = {},
    headline = "",
  } = options;

  return (
    <div className={styles?.parameter}>
      {headline ? (
        headline
      ) : (
        <h4 className={styles?.headline}>{parameterName}</h4>
      )}
      <div
        className={
          showMoreEnabled && showMoreActive ? styles?.parameterContent : null
        }
      >
        <Checkbox.Group
          style={{ width: "100%" }}
          onChange={(checkedValues) => {
            handleChange(parameterTitle, checkedValues);
          }}
          value={get(selected, [parameterTitle])}
          name={parameterTitle}
        >
          {parameterValues.map((parameterValue, index) => {
            if (showMoreEnabled && showMoreActive && index >= showMoreLimit) {
              return null;
            }

            const parameterValueId = get(
              parameterValue,
              "id",
              encodeURIComponent(parameterValue?.value)
            );
            const parameterValueValue = get(parameterValue, "value");
            const parameterValueTitle = encodeURIComponent(
              get(
                parameterValue,
                "urlName",
                get(parameterValue, "v2-value", parameterValueValue)
              )
            );

            return (
              <div key={`category-${parameterId}-${parameterValueId}-${index}`}>
                <Checkbox 
                  value={parameterValueTitle}
                  className={globalStyles.filterCheckbox}
                >
                  <span className={globalStyles.label}>{get(parameterValue, "v2-label", parameterValueValue)}</span>	
                  <span className={globalStyles.count}>{get(parameterValue, "productCount", 0)}</span>
                </Checkbox>
              </div>
            );
          })}
        </Checkbox.Group>
      </div>
      {showMoreEnabled ? (
        <span
          className={styles?.linkShowMore}
          onClick={showMoreToggle(parameterId)}
        >
          {showMoreActive ? "zobraziť viac" : "zobraziť menej"}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

export default CategoryElementCheckbox;
